{
  "此页面需要平台工作区": "This page requires the platform workspace",
  "无平台工作区访问权限": "You do not have access to the platform workspace",
  "切换到平台工作区": "Switch to platform workspace"
}
